import { render } from "./OnlyValue.vue?vue&type=template&id=0e576964&ts=true"
import script from "./OnlyValue.vue?vue&type=script&lang=ts"
export * from "./OnlyValue.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__